export interface DebouncerOpts {
  waitMs: number;
}

export class Debouncer {
  private readonly waitMs;
  private isCallbackPending = false;
  private runningCallbackPromise: Promise<void> | null = null;
  private debounceTimerId: NodeJS.Timeout | null = null;

  constructor(
    private readonly callback: () => void | Promise<void>,
    { waitMs }: DebouncerOpts
  ) {
    this.waitMs = waitMs;
  }

  fire() {
    if (this.debounceTimerId) {
      clearTimeout(this.debounceTimerId);
    }

    this.debounceTimerId = setTimeout(async () => {
      this.debounceTimerId = null;

      if (this.runningCallbackPromise) {
        await this.runningCallbackPromise;
      }

      this.runningCallbackPromise = Promise.resolve(this.callback()).finally(
        () => {
          this.runningCallbackPromise = null;
        }
      );
    }, this.waitMs);
  }
}
